import {
	post,
	get
} from "../util/crmAxios";
import { getBasicUrls } from "../util/config";
const schoolm = getBasicUrls().schoolm
const schoolApi = getBasicUrls().schoolm
const newAgentManage = getBasicUrls().newAgentManage
export const addRecord = (params) => post('/crm/customerfollow/addRecord', params) //添加跟进记录
export const customArticle = (params) => get('/crm/customer/customArticle', params) //学员详情
export const customArticleCallCenter = (params) =>
  get("/crm/customer/customArticleCallCenter", params); //学员详情(客服中心)
export const listRecord = (params) => post('/crm/customerfollow/listRecord', params) //跟进记录列表
// 保存线索信息和跟进记录
export const updateCustomInfoAndRecord = (params) => post("/crm/customer/updateCustomInfoAndRecord", params);
// 转交线索
export const changeCustomCrOwner = (params) =>
  post("/crm/customer/changeCustomCrOwner", params);
// 转交线索（驾驶舱 1.3）
export const changeCustomOwner = (params) =>
  post("/crm/customManage/changeCustomOwner", params);
// 标记失效
export const signInvalid = (params) => post('/crm/customerfollow/markingFailureForCustom', params)
export const updateCustomFollowStatus = (params) =>
  post("/crm/customer/updateCustomFollowStatus", params); //更新线索跟进状态
export const addEditCustomer = (params) => post('/crm/customer/addEditCustomer', params) //编辑学员
export const checkLearnMachineAuditionv2 = (params) => post('/erp/studentAudition/checkLearnMachineAuditionv2', params)  //开通体验是否有额度及手机号校验
export const queryNormalLimit = (params) => post('/erp/studentAudition/queryNormalLimit', params) //查询当前经销商额度
//export const getDictionaryList = (params) => get('/base/dictionary/getDictionaryList', params) //字典查询
export const getChannelList = (params) => get('/crm/channel/getChannelList ', params) //字典查询来源
export const callRecordList = (params) => post('/crm/customerfollow/callRecordList ', params) //学员通话记录
export const queryFeedbackListByStudentId = (params) => post('/erp/teacherfeedback/queryFeedbackListByStudentId ', params) //家校服务-学员课后反馈列表
export const updateCallInfo = (params) => get('/crm/customer/updateCallInfo', params) //更新学员通话信息
export const getServiceInfo = (params) => post(schoolApi + 'starServiceCenter/callService/serviceInfo', params) //视频通话服务开通情况
export const getCallRecord = (params) => post(schoolApi + 'starServiceCenter/callService/callRecord', params) //学员视频通话记录
export const shutdown = (params) => post(schoolApi + 'starServiceCenter/callService/shutdown', params) //视频通话服务关闭
export const cancelShutdown = (params) => post(schoolApi + 'starServiceCenter/callService/cancelShutdown', params) //视频通话服务取消关闭
export const accountUserList = (params) => post(schoolApi + 'starServiceCenter/callService/accountUserList', params) //学员视频服务管理列表
export const operateLogs = (params) => post(schoolApi + 'starServiceCenter/callService/operateLogs', params) //视频通话服务操作日志
export const payDisInfo = (params) => post(schoolApi + 'starServiceCenter/callService/payDisInfo', params) // 待开通视频通话服务信息
export const payConfirm = (params) => post(schoolApi + 'starServiceCenter/callService/payConfirm', params) // 支付确认
export const checkSN = (params) => post('/crm/customerfollow/checkSN', params) //经销商系统通过SN码获取绑定的智适应账号信息
export const queryAccountUserBySn = (params) => post('/crm/customerfollow/queryAccountUserBySn', params) //#经销商系统校验智适应账号
export const checkAccount = (params) => post('/crm/customerfollow/checkAccount', params) //经销商系统校验智适应账号
export const commitOrder = (params) => post('/crm/customerfollow/commitOrder', params) //经销商系统潜在客户提交订单
export const queryShareUser = (params) => get('/crm/customerfollow/queryShareUser', params) //经销商系统潜在客户提交订单
export const queryCustomOrderList = (params) => post('/crm/customerfollow/queryCustomOrderList', params) //字典查询来源
export const deleteCustomOrder = (params) => post('/crm/customerfollow/deleteCustomOrder', params) //字典查询来源
export const queryCustomSourceStatisticsList = (params) => post(schoolm + 'custom/queryCustomSourceStatisticsList', params) //销售中心-潜在客户-渠道来源统计-查询列表
export const serviceStudentRelateCustom = (params) => post(schoolm + 'custom/serviceStudentRelateCustom', params) //销售中心-潜在客户-渠道来源统计-查询列表
export const queryFullTimeApplyList = (params) => post(newAgentManage + 'v1/fulltimeapply/list', params) //获取申报记录列表
export const queryFullTimeApplyDetail = (params) => post(newAgentManage + 'v1/fulltimeapply/detail', params) //获取申报记录详情
export const submitFullTimeApply = (params) => post(newAgentManage + 'v1/fulltimeapply/submit', params) //提交申报







